import React from 'react'
import Page from 'layouts/Page'
import { Node, md } from 'djedi-react'
import Masthead, { MastheadOverlap } from 'layouts/Masthead'
import Container from 'layouts/Container'
import Box, { BoxSection } from 'layouts/Box'

export default () => (
  <Page title="Så funkar det" plain>
    <Masthead overlap plain>
      <Container size="medium">
        <h1>
          <Node uri="howitworks/heading">Så här kommer du igång!</Node>
        </h1>
      </Container>
    </Masthead>
    <MastheadOverlap>
      <Container size="medium">
        <Box>
          <BoxSection>
            <Node uri="howitworks/text.md">
              {md`
                1. Sök på ett intresse och/eller ditt barns skola och hitta din ledare.
                2. Skapa ett konto och en aktivitet och välj när, var och hur länge.
                3. Bjud in föräldrar vars barn du vill bjuda in till gruppen.
                4. Alla väljer hur och när de vill betala via Klarna Checkout.
                5. Kommunicera med ledare/andra gruppmedlemmar på vår chattfunktion och påbörja aktiviteten!

                Du kan också hitta en öppen grupp med en aktivitet
                kring ett intresse, som ditt barn kan gå med i.
                Eller om du saknar något, lägg upp en ny öppen
                grupp kring ett intresse även om du inte hittat en
                ledare, så gör vi vårt yttersta för att ditt barn
                ska hitta just sin ledare och sitt sammanhang.
              `}
            </Node>
          </BoxSection>
        </Box>
      </Container>
    </MastheadOverlap>
  </Page>
)



// WEBPACK FOOTER //
// ../source/static/HowItWorks.js